import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Reminder } from 'src/app/models/server/reminder';
import { ConnectedUsersStateService } from '../state/connected-users-state.service';
import { ViewsStateService } from '../state/views-state.service';
import { ServiceBase } from './service-base';

@Injectable({
    providedIn: 'root',
})
export class RemindersService extends ServiceBase {
    constructor(
        private http: HttpClient,
        public override connectedUserStateService: ConnectedUsersStateService,
        public viewsStateService: ViewsStateService
    ) {
        super(connectedUserStateService);
    }

    /**
     * Liste les rappels d'un dossier.
     * @param viewId : Id de la vue.
     * @param folderId : Id du dossier
     * @returns Liste de rappels.
     */
    public List(viewId: number, folderId: string): Observable<Reminder[]> {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
            }),
        };

        return this.http.get<Reminder[]>(this.baseUrl + `/api/organizations/${this.organizationId}/views/${viewId}/folders/${folderId}/reminders`, httpOptions).pipe(
            map((x) => {
                return x;
            })
        );
    }

    /**
     * Ajoute un rappel
     * @param viewId Id de la vue à laquelle appartient le dossier.
     * @param folderId Id du dossier.
     * @param reminder : Instance du rappel.
     * @returns : L'instance du rappel créé.
     */
    public add(viewId: number, folderId: string, reminder: Reminder): Observable<Reminder> {
        const httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
        };

        reminder.viewId = viewId;

        return this.http.post<Reminder>(this.baseUrl + `/api/organizations/${this.organizationId}/views/${viewId}/folders/${folderId}/reminders`, reminder, httpOptions).pipe(
            map((x) => {
                return x;
            })
        );
    }

    /**
     * Met à jour un rappel
     * @param viewId Id de la vue à laquelle appartient le dossier.
     * @param folderId Id du dossier.
     * @param reminder : Instance du rappel.
     * @returns : L'instance du rappel modifié.
     */
    public update(viewId: number, folderId: string, reminder: Reminder): Observable<Reminder> {
        const httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
        };

        reminder.viewId = viewId;

        return this.http
            .put<Reminder>(this.baseUrl + `/api/organizations/${this.organizationId}/views/${viewId}/folders/${folderId}/reminders/${reminder.id}`, reminder, httpOptions)
            .pipe(
                map((x) => {
                    return x;
                })
            );
    }

    /**
     * Supprime un rappel
     * @param viewId : Id de la vue.
     * @param reminder : Instance du rappel.
     */
    public delete(viewId: number, reminder: Reminder): Observable<boolean> {
        const httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
        };

        return this.http
            .delete<boolean>(this.baseUrl + `/api/organizations/${this.organizationId}/views/${viewId}/folders/${reminder.folderId}/reminders/${reminder.id}`, httpOptions)
            .pipe(
                map((x) => {
                    return x;
                })
            );
    }
}
